import FieldGroup from "./FieldGroup";

const FontSelect = ({ fontFamilies, onFontSelect }) => {
  return (
    <div>
      <label className="label-3 block">Select a font stack</label>
      <select
        className="form-input"
        onChange={(e) => {
          onFontSelect(
            fontFamilies.find((item) => item.type === e.target.value)
          );
        }}
      >
        {fontFamilies.map((option) => (
          <option key={option.type} value={option.type}>
            {option.type}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FontSelect;
